/**
 * Filter function for MUI Autocomplete that adds a "Create" option when the input doesn't match any existing option
 */
import { i18n } from "i18next";

export const filterOptionsWithCreate = (options: string[], params: { inputValue: string }, i18n?: i18n) => {
    const filtered = options.filter((option) => option.toLowerCase().includes(params.inputValue.toLowerCase()));

    if (params.inputValue !== '' && !filtered.includes(params.inputValue)) {
        const createText = i18n ? i18n.t('transactions.modal.form.createAccount', { account: params.inputValue }) : `Create "${params.inputValue}"`;
        filtered.push(createText);
    }

    return filtered;
};

/**
 * Checks if a value is a "Create" option and extracts the actual value to create
 */
export const extractCreateValue = (value: string | null, i18n?: i18n): string | null => {
    if (!value) return null;
    
    // Get the create text pattern without the account value
    const createPattern = i18n 
        ? i18n.t('transactions.modal.form.createAccount', { account: '' }).replace('""', '') 
        : 'Create ""';
    
    // Check if the value starts with the create pattern
    if (value.startsWith(createPattern.trim())) {
        // Extract the value between the quotes
        const match = value.match(/"([^"]*)"/);
        return match ? match[1] : value;
    }
    
    return value;
};
